import React from 'react';

function AboutPage() {
  return <h2 className="text-2xl font-bold mb-4">About Page</h2>;
}

export default AboutPage;